// extracted by mini-css-extract-plugin
export default {"cas":"index_cas__NnBTT"};